export const kgsLogo = 'https://kgs.nyc3.cdn.digitaloceanspaces.com/uploads/hbC0ocuRD41Btvm2JRqK9gkjCxMPkH2YIXShLG5Q.png'